module.exports = __webpack_public_path__ + "static/img/pic2.bdf7ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case4/pic2.png
// module id = 7Ozo
// module chunks = 1